import { Button, Heading, Text } from '@noorden-insurtech/alba-design-system';
import { Link } from '@tanstack/react-router';

interface SuccessMessageProps {
  title: string;
  message: string;
  buttonText: string;
  buttonLink: string;
}

export function SuccessMessage({
  title,
  message,
  buttonText,
  buttonLink,
}: SuccessMessageProps) {
  return (
    <div className='flex flex-col gap-6 items-center justify-center w-full'>
      <div className='flex flex-col gap-2 items-start justify-center w-full text-[#2c2864]'>
        <Heading size='lg' className='text-[#2c2864] font-bold'>
          {title}
        </Heading>
        <Text size='sm' className='text-[#2c2864]'>
          {message}
        </Text>
      </div>

      <Link to={buttonLink} className='w-full'>
        <Button
          variant='primary'
          size='large'
          className='w-full h-[48px] bg-[#2c2864] text-[#f9f9f9] text-[20px] font-bold rounded-[16px]'
        >
          {buttonText}
        </Button>
      </Link>
    </div>
  );
}
